import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d03f33e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "RenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "屏幕中央会出现缺失了一条边的黑色正方形，每次只出现一个，请你判断正方形缺失的一条边位于哪个方向，并在该正方形被覆盖后，将鼠标移至该方向边框外区域，并点击鼠标。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft20"
}, "闯关成功，点击右下角按钮继续!", -1));
const _hoisted_5 = {
  class: "flex flex-col"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确答案：", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您的答案：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_FlashBox = _resolveComponent("FlashBox");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_col = _resolveComponent("el-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), $data.alertVisible ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_FlashBox, {
      items: $props.data.rightAnswers,
      displayTime: $props.data.interval,
      onFinish: $options.onFinish
    }, null, 8, ["items", "displayTime", "onFinish"])]),
    _: 1
  })), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_col, {
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.rightAnswers, (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          type: "info",
          style: {
            "width": "30px",
            "margin-left": "8px"
          },
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString({
            0: '上',
            1: '右',
            2: '下',
            3: '左'
          }[ra]), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }), $props.review ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.review.answer.split(','), (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          style: {
            "width": "30px",
            "margin-left": "8px"
          },
          type: $props.data.rightAnswers[rai] == ra ? 'success' : 'danger',
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString({
            0: '上',
            1: '右',
            2: '下',
            3: '左'
          }[ra]), 1)]),
          _: 2
        }, 1032, ["type"]);
      }), 128))]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}